import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import Image from 'next/image'
import { useTranslation } from 'react-i18next'
import { ParsedPricingInfo } from 'utils/apiUtils/prices'
import LeidSmartDescription from 'app/components/shared/ui/cards/ProductCard/LeidSmartDescription'

type Props = {
  pricing: ParsedPricingInfo
  isImmediateOrder: boolean
}

const AboutLeidSmartCard = ({ pricing, isImmediateOrder }: Props) => {
  const { t } = useTranslation()

  return (
    <Box
      display="flex"
      flexDirection={{ base: 'column', lg: 'row' }}
      alignItems="center"
      gap={10}
      border="1px solid"
      borderColor="updatedLeid.lightGreen"
      borderRadius="md"
      paddingTop="20px"
      paddingBottom="20px"
      marginTop="20px"
      paddingLeft={{ base: '16px', lg: '0' }}
    >
      <Box width="30%" display="flex" alignItems="center" justifyContent="center" borderColor="updatedLeid.lightGreen">
        <Image
          src="/leid_smart/badge.svg"
          alt="Leid Smart Badge"
          width={118}
          height={120}
          style={{ marginLeft: '10px' }}
          loading="lazy"
          decoding="async"
          data-nimg="1"
        />
      </Box>
      <Box paddingRight="16px">
        <Text fontSize="sm" fontWeight="semibold" paddingBottom="10px" paddingLeft="15px">
          {t('leidSmart.leidSmartShortTerms.title')}
        </Text>

        <LeidSmartDescription pricing={pricing} cancelationAvailable={!isImmediateOrder} />
      </Box>
    </Box>
  )
}

export default AboutLeidSmartCard
